import React, {useEffect,useState} from "react";
import { Modal, Form, TimePicker, Button, Steps ,Select,message} from "antd";
import PosService from "../../../services/PosService";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import TableConfiguration from "../../SeatingManagement/TableConfiguration";
import SeatingManagement from "../../SeatingManagement";
import SettingsService from "../../../services/SettingsService";
import moment from "moment"

const { Option } = Select;
const { Step } = Steps;


export default function AddReservationSlots({ data,updateData, ...props }) {
  const formRef = React.createRef();
  const [form] = Form.useForm();
  const history = useHistory();
  const adminRestaurant = useSelector((state) => state.admin);
  const [selectedTable,setSelectedTable] = useState([])

  const [current, setCurrent] = useState(0);
  const [selectedDays, setSelectedDays] = useState([]);
  const [selectedTime, setSelectedTime] = useState();


  const next = () => {
    if(selectedDays.length && selectedTime){
      setCurrent(current + 1);
    } else {
      message.warning('Please select time slot and days');
    }
  };

  const prev = () => {
    setCurrent(current - 1);
  };

  

  

 

  const steps = [
    {
      title: 'Step 1',
      content: "",
    },
    {
      title: 'Step 2',
      content: "",
    },
  ];

  useEffect(()=>{
    if(updateData)
      {
        const selectedTablesEdit = updateData?.tables.split(",").map(item => {
          return {
            table_number: Number(item)
          }
        })
        setSelectedTable(selectedTablesEdit)
        setSelectedDays(updateData?.operational_days.split(','))
        setSelectedTime([updateData?.start_time,updateData?.end_time])
        
      }
  },[updateData])

  
  const options = [
    {label:"Monday", value: "Mon"},
    {label:"Tuesday", value: "Tue"},
    {label:"Wednesday", value: "Wed"},
    {label:"Thursday", value: "Thu"},
    {label:"Friday", value: "Fri"},
    {label:"Saturday", value: "Sat"},
    {label:"Sunday", value: "Sun"},
  ]

  const handleChange = (value) => {
    setSelectedDays(value)
  };

  const onChange = (time, timeString) => {
    setSelectedTime(timeString)
  };

  const addedTables = (item) => {
    if(selectedTable.some(items => items.table_number === item.table_number))
      setSelectedTable(selectedTable.filter(items => items.table_number !== item.table_number))
    else
    setSelectedTable([item,...selectedTable])

  }

  const addSlots = async()=>{
    if(selectedTable.length === 0){
      message.warning('Please select table');
    } else {
      const payload =  {
        tables: selectedTable?.map(item => item.table_number)?.toString(),
        operational_days: selectedDays?.toString(),
        start_time: selectedTime?.[0],
        end_time: selectedTime?.[1]
    }
    if(updateData)
      await SettingsService.updateReservationSlots(adminRestaurant,payload,updateData?.id)
    else
     await SettingsService.addReservationSlots(adminRestaurant,payload)
    message.success("Created new reservation slots")
    props.addSlots()
    }
  }

  return (
    <Modal
      title={"Add Reservation Slots"}
      open={props.modalOpen}
      className="reservation-modal"
      footer={null}
      onCancel={() => props.closeModal(false)}
    >
      <div>
      <Steps current={current}>
        {steps.map((item) => (
          <Step key={item.title} title={item.title} />
        ))}
      </Steps>
      {/* <div className="steps-content" style={{ marginTop: '20px' }}>
        {steps[current].content}
      </div> */}


{current == 0 ?
<div className="step1-slots">
         <div className="step-buttons">
     <div>
      Time Slots
     </div>
     <TimePicker.RangePicker use12Hours format="h:mmA" onChange={onChange}
     defaultValue={updateData?[moment(updateData?.start_time, 'h:mmA'), 
      moment(updateData?.end_time, 'h:mmA')
     ]:selectedTime ? [moment(selectedTime[0], 'h:mmA'), moment(selectedTime[1], 'h:mmA')] : []}/>
     </div>
     

     <div className="step-buttons">
      <div> Select days</div>
      <Select
      mode="multiple"
      allowClear
      style={{
        width: '100%',
      }}
      defaultValue={updateData?updateData?.operational_days.split(','):selectedDays || []}
      placeholder="Please select"
      onChange={handleChange}
      options={options}
    />
     </div>
     <div className="step-buttons">
     <Button onClick={()=>next()} type="primary">Next</Button>
</div>
     </div> :
     <div className="step1-slots">
     <div>Select Table</div>
     <div className="table-selections">
     {selectedTable.map(item=> <div className="selected-table">{item?.table_number}</div>)}
     </div>
     <SeatingManagement isFromAddPopup addedTables = {addedTables}
     selectedTable={selectedTable} selectAllTables = {setSelectedTable}/> 

<div>
     <Button style={{ marginRight: 8 }} onClick={()=>prev()}>
          Previous
        </Button>
        <Button type="primary" onClick={()=>addSlots()}>
          Submit
        </Button>
     </div>
     </div>}
     </div>
    </Modal>
  );
}
